import { CountPanel, CountText, CountValue, VisitorCountText } from '../styled';

export const CONVERSION_COUNTS_TEST_ID = 'conversion-counts';

type ConversionCountsProps = {
  totalConversion?: number | string;
};

export const ConversionCounts = ({ totalConversion }: ConversionCountsProps) => {
  const conversionMetrics = [
    {
      key: 'total-users-converted',
      text: 'Total users converted:',
      value: totalConversion?.toLocaleString() || <CountText>N/A</CountText>,
    },
  ];
  return (
    <CountPanel data-test={CONVERSION_COUNTS_TEST_ID}>
      {conversionMetrics.map((count: any) => {
        return (
          <VisitorCountText key={count.key}>
            <CountText>{count.text}</CountText>

            <CountValue data-test={count.key}>{count.value}</CountValue>
          </VisitorCountText>
        );
      })}
    </CountPanel>
  );
};
